import {
  CLOUDINARY_BROWSE_LOADING,
  CLOUDINARY_VIDEO_URL,
  CLOUDINARY_VIDEO_ERROR,
  CLOUDINARY_VIDEOS,
  CLOUDINARY_IMAGE_URL,
  CLOUDINARY_IMAGES,
  // CLOUDINARY_PUBLIC_ID,
  FACEBOOK_AD_FORM_DETAILS,
  FACEBOOK_AD_FORM_ERROR,
  FACEBOOK_AD_ID,
  FACEBOOK_AD_ERROR,
} from "../../types";

const AdReducer = (state, action) => {
  switch (action.type) {
    case CLOUDINARY_BROWSE_LOADING:
      return { ...state, browse_loading: action.payload };

    case CLOUDINARY_VIDEO_URL:
      return { ...state, video_url: action.payload };

    case CLOUDINARY_VIDEO_ERROR:
      return { ...state, video_error: action.payload };

    case CLOUDINARY_VIDEOS:
      const data = action.payload;

      let videos = state.videos;

      if (videos) {
        const current_ids = videos.map((video) => video.asset_id);

        data.resources.map((video) => {
          if (!current_ids.includes(video.asset_id)) {
            videos.push(video);
          }
        });
      } else {
        videos = data.resources;
      }

      let video_next_cursor = null;

      if (videos.length < data.total_count) {
        video_next_cursor = data.next_cursor;
      } else {
        video_next_cursor = null;
      }

      return { ...state, videos, video_next_cursor };

    case CLOUDINARY_IMAGE_URL:
      const url = action.payload[0];
      const ad_id = action.payload[1];

      state.form_details[ad_id]["image"] = url;

      return { ...state, form_details: state.form_details };

    case CLOUDINARY_IMAGES:
      let images = state.images;

      if (images) {
        const current_ids = images.map((image) => image.asset_id);

        action.payload.resources.map((image) => {
          if (!current_ids.includes(image.asset_id)) {
            images.push(image);
          }
        });
      } else {
        images = action.payload.resources;
      }

      let image_next_cursor = null;

      if (images.length < action.payload.total_count) {
        image_next_cursor = action.payload.next_cursor;
      } else {
        image_next_cursor = null;
      }

      return { ...state, images, image_next_cursor };

    // case CLOUDINARY_PUBLIC_ID:
    //   return { ...state, video_public_id_found: action.payload };

    case FACEBOOK_AD_FORM_DETAILS:
      return { ...state, form_details: action.payload };

    case FACEBOOK_AD_FORM_ERROR:
      return { ...state, form_errors: action.payload };

    case FACEBOOK_AD_ID:
      return { ...state, ad_id: action.payload };

    case FACEBOOK_AD_ERROR:
      return { ...state, ad_error: action.payload };

    default:
      return state;
  }
};

export default AdReducer;